module.exports = __webpack_public_path__ + "img/2.a9f2cd7a.jpg";